import { EVENT_TYPE_USER, EVENT_TYPE_DTMP, EVENT_TYPE_MACH } from '../../../constants';

const defaultEventTypeSelection = [EVENT_TYPE_USER, EVENT_TYPE_MACH, EVENT_TYPE_DTMP];
const validEventTypes = new Set(defaultEventTypeSelection);
const limitedListViewType = 'limited list view';

export function getDefaultEventTypeSelection() {
  return [...defaultEventTypeSelection];
}

export function normalizeEventTypeSelection(rawEventTypeSelection) {
  if (!Array.isArray(rawEventTypeSelection)) {
    return getDefaultEventTypeSelection();
  }

  const normalizedSelection = rawEventTypeSelection.filter((eventType) =>
    validEventTypes.has(eventType)
  );

  if (normalizedSelection.length > 0) {
    return [...new Set(normalizedSelection)];
  }

  return getDefaultEventTypeSelection();
}

export function includesEventType(enabledEventTypes, eventType) {
  return normalizeEventTypeSelection(enabledEventTypes).includes(eventType);
}

export function getDefaultEventType(enabledEventTypes, preferredEventType) {
  const normalizedEventTypes = normalizeEventTypeSelection(enabledEventTypes);

  if (normalizedEventTypes.includes(preferredEventType)) {
    return preferredEventType;
  }

  return normalizedEventTypes[0] || EVENT_TYPE_USER;
}

export function shouldShowEventTypeColumns(configuredViews) {
  if (!Array.isArray(configuredViews) || configuredViews.length === 0) {
    return true;
  }

  return configuredViews.some((viewType) => viewType !== limitedListViewType);
}

export function clampLimitedListEventCount(rawLimitedListEventCount) {
  // Schema validation protects newly edited layouts, but stale saved layouts can still carry
  // invalid values. Clamp here so limited-list fetching and rendering stays bounded.
  const parsedLimitedListEventCount = Number(rawLimitedListEventCount);

  if (!Number.isFinite(parsedLimitedListEventCount)) {
    return 10;
  }

  return Math.min(100, Math.max(1, parsedLimitedListEventCount));
}
